export function stickySchedule() {
    let stickyLink = $(".sticky-schedule");
    $(window).on("load scroll", function () {
        if (window.innerWidth >= 1200) {
            let scrollTop = $(window).scrollTop();
            let windowHeight = $(window).innerHeight();
            if (scrollTop > windowHeight ) {
                stickyLink.addClass("active");
            }else {
                stickyLink.removeClass("active");
            }
        }

    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickySchedule.js